import { render, staticRenderFns } from "./ReminderButton.vue?vue&type=template&id=2bcad3d4&scoped=true"
import script from "./ReminderButton.vue?vue&type=script&lang=js"
export * from "./ReminderButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcad3d4",
  null
  
)

export default component.exports